import React from 'react';
import { GenericHierarchyFlow } from '../PreviewApprovalHierarchyReactFlow';
import { StampOptions } from '../StamperView';
import {
  ApprovalSetupMap,
  ApprovalSetupMapVariables,
} from './__generated__/ApprovalSetupMap';
import { NodeView } from './NodeView';

import APPROVAL_SETUP_MAP from './ApprovalSetupMap.graphql';

export interface HierarchyNode {
  children?: HierarchyNode[];
  isBranch?: boolean | null;
  isTree?: boolean | null;
  id?: string | null;
  name?: string | null;
  subTopic?: string | null;
  topic?: string | null;
  approvalType?: string | null;
  level?: number | null;
  x?: number;
  y?: number;
  parentId?: string | null;
  width?: number;
  height?: number;
}

interface ApprovalFlowProps {
  entityId: string;
  getApprovalType: (approvalType: string) => void;
  stampEnteredData?: (data: StampOptions) => void;
}

export const ApprovalFlow: React.FC<ApprovalFlowProps> = ({
  entityId,
  getApprovalType,
  stampEnteredData,
}) => {
  // Function to extract nodes from the query data
  const getNodesFromData = (data: ApprovalSetupMap) => {
    return data?.approvalSetupMap?.nodes;
  };

  // Handle node data to extract approvalType
  const handleNodeData = (nodeData: HierarchyNode | undefined) => {
    if (nodeData?.approvalType) {
      getApprovalType(nodeData.approvalType);
    }
  };

  return (
    <GenericHierarchyFlow<ApprovalSetupMap, ApprovalSetupMapVariables>
      entityId={entityId}
      query={APPROVAL_SETUP_MAP}
      queryVariables={{
        entityId,
        orderBy: ['SORT_ORDER_DESC'],
      }}
      getNodesFromData={getNodesFromData}
      onNodeData={handleNodeData}
      NodeViewComponent={(props) => (
        <NodeView nodeData={props.data} key={props.data.id} />
      )}
      defaultNodeHeight={170}
    />
  );
};
